// extracted by mini-css-extract-plugin
export var brand = "_26-9";
export var compact = "_26-6";
export var extraSmall = "_26-7";
export var icon = "_26-0";
export var large = "_26-4";
export var light = "_26-1";
export var medium = "_26-5";
export var outline = "_26-b";
export var primaryDark = "_26-a";
export var primaryLight = "_26-8";
export var primaryModern = "_26-c";
export var success = "_26-2";
export var successSolid = "_26-3";